import "./ContactRequest.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import QuickQuote from "./sections/QuickQuote";
import KeyBenefits from "./sections/KeyBenefits";
import Footer from "@/reusable_sections/Footer";
export default function ContactRequestPage() {
  return <div>
      <Header />
      <Hero />
      <QuickQuote />
      <KeyBenefits />
      <Footer />
    </div>;
}